import { ResolveFn } from '@angular/router';
import { ICompany } from '../../modules/companies/shared/interfaces/company.interface';
import { tap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { CompaniesService } from '../../modules/companies/companies.service';
import { TeamProjectService } from '../../services/team-project.service';
import { IdentityService } from '../../services/identity.service';
import { TeamProject } from '../../interfaces/team-project';
import { of } from 'rxjs';

export const TeamProjectsResolver: ResolveFn<unknown> = () => {
  const companiesService = inject(CompaniesService);
  const teamProjectService = inject(TeamProjectService);
  const identityService = inject(IdentityService);

  const teamProjectFromLocalStorage = teamProjectService.teamProjectFromLocalStorage;

  if (teamProjectFromLocalStorage) {
    teamProjectService.setTeamProject(teamProjectFromLocalStorage);

    return of(null);
  }

  if (identityService.isCompanyAdmin()) {
    return identityService.getCompaniesProjects().pipe(
      tap(({ Companies }) => {
        const teamProject = teamProjectService.transformCompanyToProject(Companies[0]);

        teamProjectService.setTeamProject(teamProject);
      }),
    );
  }

  if (identityService.isSuperAdmin()) {
    return companiesService.list().pipe(
      tap((companies: ICompany[]) => {
        const sortedCompanies = companiesService.getSortedCompaniesList(companies);
        const transformedCompanies = sortedCompanies.map(company => teamProjectService.transformCompanyToProject(company));

        teamProjectService.setTeamProject(transformedCompanies[0]);
      }),
    );
  }

  return identityService.getTeamProjects().pipe(
    tap(teams => {
      const firstTeam = teams[0];
      const teamProject = { ...firstTeam, LogoUrl: firstTeam.LogoUrl } as TeamProject;

      teamProjectService.setTeamProject(teamProject);
    }),
  );
};
